<template>
  <div class="c-creative">
    <div class="c-creative-wrapper g-clearfix" :style="setScrollWidth">
      <div v-for="(elem, id) of data" :key="id" class="c-creative-item">
        <span class="m-remove" @click="$emit('on-delete', { id, type })">x</span>
        <div v-for="(item, i) of elem.template" :key="i" :class="creativeClasses(item)">
          <creat-video
            v-if="item.element === 'ELEMENT_TYPE_VIDEO'"
            v-model="item[item.name]"
            :name="item.name"
            :restriction="item.restriction"
            :required="item.required"
            :type="item.element"
            :description="item.description"
            :source="source"
            :local="local"
            :verify="verify"
            @select="selectMedia(id, $event)"
          />
          <creat-image
            v-if="item.element === 'ELEMENT_TYPE_COVER'"
            v-model="item[item.name]"
            :name="item.name"
            :restriction="item.restriction"
            :required="item.required"
            :type="item.element"
            :description="item.description"
            :source="source"
            :local="local"
            :verify="verify"
            @select="selectMediaCover(id, item[item.name], elem.template[0].video, $event)"
          />
          <creat-image
            v-if="item.element === 'ELEMENT_TYPE_IMAGE' && item.field === 'FIELD_TYPE_STRING'"
            v-model="item[item.name]"
            :name="item.name"
            :restriction="item.restriction"
            :required="item.required"
            :type="item.element"
            :description="item.description"
            :source="source"
            :local="local"
            :verify="verify"
            @select="selectMedia(id, $event)"
          />
          <!-- 数组类型 -->
          <template v-if="item.element === 'ELEMENT_TYPE_STRUCT' || item.field === 'FIELD_TYPE_STRING_ARRAY'">
            <div v-for="(met, idx) in item.children" :key="idx" class="c-group-item">
              <creat-image
                v-if="met.element === 'ELEMENT_TYPE_IMAGE' && item.field === 'FIELD_TYPE_STRING_ARRAY'"
                v-model="met[met.name]"
                :name="met.name"
                :restriction="met.restriction"
                :required="met.required"
                :type="met.element"
                :description="met.description"
                :source="source"
                :local="local"
                :verify="verify"
                @select="selectMediaGroup(id, $event)"
              />
            </div>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { isEmpty } from '@/common/js/utils'
import CreatVideo from './creat-video.vue'
import CreatImage from './creat-image.vue'
export default {
  name: 'creative',
  components: { CreatVideo, CreatImage },
  props: {
    data: {
      type: Array
    },
    verify: {
      type: Boolean
    },
    source: {
      type: Array
    },
    local: {
      type: Boolean,
      default: true
    },
    type: {
      type: String
    }
  },
  computed: {
    setScrollWidth() {
      let width = 268
      if (this.type === 'video') width = 550
      else if (this.type === 'group') width = 788
      return { width: `${this.data.length * width}px` }
    },
    creativeClasses() {
      return (item) => {
        let cls = ''
        if (item.element === 'ELEMENT_TYPE_VIDEO') cls = 'c-creative-video'
        else if (item.element === 'ELEMENT_TYPE_COVER') cls = 'c-creative-cover'
        else if (item.field === 'FIELD_TYPE_STRING_ARRAY') cls = 'c-creative-group'
        else cls = 'c-creative-media'
        return [cls]
      }
    }
  },
  methods: {
    selectMedia(index, $event) {
      this.$emit('on-select', Object.assign($event, { index }))
    },
    selectMediaCover(index, image, video, $event) {
      if (isEmpty(image)) {
        // 封面转成视频
        $event = Object.assign({}, $event, {
          name: 'video',
          type: 'ELEMENT_TYPE_VIDEO',
          size: 102400
        })
      }
      if (!isEmpty(video)) $event.smart = video
      this.$emit('on-select', Object.assign($event, { index }))
    },
    selectMediaGroup(index, $event) {
      this.$emit('on-select', Object.assign($event, { index, mult: 3, batch: true }))
    },
    uploadImage(params) {
      const { index, file, vertical, idx } = params
      this.$emit('on-upload', { type: this.type, index, idx, file, vertical })
    },
    loadingImage(params) {
      const { index, idx } = params
      this.$emit('on-loading', { type: this.type, index, idx })
    }
  }
}
</script>
<style lang="scss" scoped>
.m-remove {
  position: absolute;
  cursor: pointer;
  color: #fff;
  width: 18px;
  height: 18px;
  line-height: 18px;
  font-size: 80%;
  border-radius: 9px;
  background-color: #ff635c;
  text-align: center;
  display: block;
  opacity: 0;
  z-index: 11;
  top: -6px;
  right: 0;
  transition: opacity 0.2s ease-in-out;
}

.c-creative {
  width: 100%;
  overflow-x: auto;
  scrollbar-width: thin;
  -webkit-overflow-scrolling: touch;
  padding: 8px 0;

  .c-creative-wrapper {
    position: relative;
    padding-bottom: 12px;

    .c-creative-item {
      display: inline-block;
      padding-right: 8px;
      position: relative;

      &:hover {
        ::v-deep .c-thumb {
          border-color: #ff635c;
        }

        .m-remove {
          opacity: 1;
        }
      }
    }

    .c-creative-media,
    .c-creative-group {
      display: inline-block;
    }

    .c-creative-video,
    .c-creative-cover {
      display: inline-block;
    }

    .c-group-item {
      display: inline-block;

      &:first-child {
        ::v-deep .c-thumb {
          border-left-width: 1px;
        }
      }

      ::v-deep .c-thumb {
        border-left-width: 0;
      }
    }
  }
}
</style>
